import { useQuery } from '@tanstack/react-query';

import { fetchMeetings } from '@/api/v4/meetings.api';
import { QueryKey } from '@/config/query-client';
import { reorderMeetings } from '@/features/action-panel/meetings/helpers/reorder-meetings';
import { editedMeetingIdState } from '@/features/action-panel/meetings/meetings.state';

import { companyIdState } from '../../company.state';
import { useAtomValue } from 'jotai';

export const useCompanyMeetings = () => {
  const companyId = useAtomValue(companyIdState);
  const editedMeetingId = useAtomValue(editedMeetingIdState);

  const fetchCompanyMeetings = async () => {
    if (!companyId) return [];

    return fetchMeetings({ organizationId: companyId });
  };

  return useQuery({
    queryKey: [QueryKey.CompanyMeetings, companyId],
    queryFn: fetchCompanyMeetings,
    select: meetings =>
      editedMeetingId ? reorderMeetings(meetings, editedMeetingId) : meetings,
    enabled: !!companyId,
    staleTime: 1000 * 60 * 5,
  });
};
